
import { skinTones, hairStyles, accessories, outfits } from "../../../mocks/characterParts";

interface CustomizationPanelProps {
  selectedSkinTone: string;
  selectedHairStyle: string;
  selectedAccessory: string;
  selectedOutfit: string;
  onSkinToneChange: (color: string) => void;
  onHairStyleChange: (style: string) => void;
  onAccessoryChange: (accessory: string) => void;
  onOutfitChange: (outfit: string) => void;
}

export default function CustomizationPanel({
  selectedSkinTone,
  selectedHairStyle,
  selectedAccessory,
  selectedOutfit,
  onSkinToneChange,
  onHairStyleChange,
  onAccessoryChange,
  onOutfitChange
}: CustomizationPanelProps) {
  return (
    <div className="w-full space-y-4">
      <div>
        <h3 className="text-xs font-semibold text-gray-600 mb-2 flex items-center gap-1.5">
          <i className="ri-palette-line text-purple-500"></i>
          Tono de piel
        </h3>
        <div className="flex gap-2">
          {skinTones.map((tone) => (
            <button
              key={tone.id}
              onClick={() => onSkinToneChange(tone.color)}
              className={`w-8 h-8 rounded-full border-2 transition-all ${
                selectedSkinTone === tone.color ? 'border-purple-500 scale-110 shadow-md' : 'border-gray-200'
              }`}
              style={{ backgroundColor: tone.color }}
              title={tone.name}
            />
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-xs font-semibold text-gray-600 mb-2 flex items-center gap-1.5">
          <i className="ri-scissors-line text-pink-500"></i>
          Cabello
        </h3>
        <div className="flex gap-1.5 flex-wrap">
          {hairStyles.map((hair) => (
            <button
              key={hair.id}
              onClick={() => onHairStyleChange(hair.type)}
              className={`px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all ${
                selectedHairStyle === hair.type 
                  ? 'bg-pink-500 text-white shadow-sm' 
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {hair.name}
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-xs font-semibold text-gray-600 mb-2 flex items-center gap-1.5">
          <i className="ri-glasses-line text-blue-500"></i>
          Accesorios
        </h3>
        <div className="flex gap-1.5 flex-wrap">
          {accessories.map((acc) => (
            <button
              key={acc.id}
              onClick={() => onAccessoryChange(acc.type)}
              className={`px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all ${
                selectedAccessory === acc.type 
                  ? 'bg-blue-500 text-white shadow-sm' 
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {acc.name}
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-xs font-semibold text-gray-600 mb-2 flex items-center gap-1.5">
          <i className="ri-shirt-line text-green-500"></i>
          Vestimenta
        </h3>
        <div className="flex gap-1.5 flex-wrap">
          {outfits.map((outfit) => (
            <button
              key={outfit.id}
              onClick={() => onOutfitChange(outfit.type)}
              className={`px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all ${
                selectedOutfit === outfit.type 
                  ? 'bg-green-500 text-white shadow-sm' 
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {outfit.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
